/**
 * Sales-Funnel:
 *   - Progress-Bar füllt sich proportional zum Scroll-Progress der Seite.
 *   - Conditional-Reveals: bestimmte Text-Inputs erscheinen erst, wenn der
 *     dazugehörige Radio-/Checkbox-Wert gewählt ist (data-reveal-if).
 *   - File-Input zeigt den gewählten Dateinamen neben dem Trigger an.
 */

export function initFunnel() {
  const form = document.querySelector('.funnel_form');
  if (!form) return;

  initProgressBar();
  initReveals(form);
  initFileInput(form);
}

function initProgressBar() {
  const fill = document.querySelector('.funnel_progress_fill');
  const bar = document.querySelector('.funnel_progress');
  if (!fill || !bar) return;

  const update = () => {
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const pct = max > 0 ? Math.min(100, Math.max(0, (window.scrollY / max) * 100)) : 0;
    fill.style.width = pct.toFixed(2) + '%';
    bar.setAttribute('aria-valuenow', String(Math.round(pct)));
  };

  update();
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        update();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
  window.addEventListener('resize', update);
}

function initReveals(form) {
  const reveals = form.querySelectorAll('[data-reveal-if]');
  reveals.forEach((reveal) => {
    const expr = reveal.dataset.revealIf || '';
    const [rawName, value] = expr.split(':');
    const trigger = reveal.dataset.revealTrigger || 'radio';
    if (!rawName) return;

    // Arrays (name="foo[]") auf den Basisnamen reduzieren — querySelectorAll
    // mit [name="foo[]"] findet ansonsten nichts (eckige Klammern sind
    // keine CSS-Pseudo-Klassen).
    const nameSelector = rawName;
    const inputs = form.querySelectorAll('input[name="' + cssEscape(nameSelector) + '"]');

    const sync = () => {
      let on = false;
      inputs.forEach((input) => {
        if (trigger === 'checkbox') {
          if (input.checked && (value === '1' ? true : input.value === value)) on = true;
        } else {
          if (input.checked && input.value === value) on = true;
        }
      });
      reveal.classList.toggle('is-visible', on);
    };

    inputs.forEach((input) => input.addEventListener('change', sync));
    sync();
  });
}

function initFileInput(form) {
  const fileInput = form.querySelector('input[type="file"][name="logo_file"]');
  const filenameSpan = form.querySelector('.funnel_upload_filename');
  if (!fileInput || !filenameSpan) return;

  fileInput.addEventListener('change', () => {
    const f = fileInput.files && fileInput.files[0];
    if (f) {
      filenameSpan.textContent = f.name;
      filenameSpan.removeAttribute('data-empty');
    } else {
      filenameSpan.textContent = 'Noch keine Datei gewählt.';
      filenameSpan.setAttribute('data-empty', '');
    }
  });
}

// Kleiner Ersatz für CSS.escape — wir brauchen nur [] escapen.
function cssEscape(str) {
  return String(str).replace(/([\[\]])/g, '\\$1');
}
